import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { catalogProcessItem } from '../../../../../../../core/catalogs/redux/actions';
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";


const INIT_STATE = {
    open: false,
    event: null,
    loading: false,
    error: null,
    savedStatus: null // null | 'success' | 'error'
};

export const assignDriverToEvent = createAsyncThunk(
    'driverPerformance/assignDriver/assign',
    async ({ rowId, driverId, esn }, { rejectWithValue, dispatch }) => {
        try {
            const result = await clientMutation(
                `
                mutation updateDriverPerformanceDriver($driverId: Int!, $rowId: String!, $esn: String!) {
                    updateDriverPerformanceDriver(driverId: $driverId, rowId: $rowId, esn: $esn) 
                }
                `,
                { 
                    driverId: driverId,
                    rowId: rowId,
                    esn: esn // is usn value from unit
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            // Validate if update was successful
            if (result?.updateDriverPerformanceDriver === true) {
                return { success: true, rowId, driverId, esn };
            }

            throw new Error('Failed to update driver assignment');

        } catch (exc) {
            ExceptionManager(exc, 'driverPerformance/views/events/modals/assignDriver', 'assignDriverToEvent');
            return rejectWithValue(exc.message || 'Error updating driver');
        }
    }
);

const driverPerformanceEventsTabAssignDriverSliceRedux = createSlice({
    name: 'driverPerformanceAssignDriver',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalAssignDriver: (state, action) => {
            state.open = true;
            state.event = action.payload.event;
            state.savedStatus = null; // Reset saved status when opening modal
            state.error = null;
        },
        closeModalAssignDriver: (state) => {
            state.open = false;
            state.event = null;
            state.error = null;
            state.savedStatus = null; // Reset saved status when closing
        },
        resetSavedStatus: (state) => {
            state.savedStatus = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(assignDriverToEvent.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.savedStatus = null;
        });
        builder.addCase(assignDriverToEvent.fulfilled, (state, action) => {
            state.loading = false;
            state.savedStatus = action.payload; // Mark as success
            state.error = null;
            // Don't close modal immediately to show success message
            // Close after timeout or manually
        });
        builder.addCase(assignDriverToEvent.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceEventsTabAssignDriverSliceRedux;

// Extract and export each action creator by name
export const { reset, openModalAssignDriver, closeModalAssignDriver, resetSavedStatus } = actions;

// Export the reducer, either as a default or named export
export default reducer;